import React from 'react';
import * as Sentry from "@sentry/react";
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';
import { queryClient } from './lib/queryClient';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

Sentry.init({
  // Masukkan DSN khusus project React dari dashboard Sentry
  dsn: import.meta.env.VITE_SENTRY_DSN || "DSN_REACT_PROJECT_KAMU",

  dataCollection: {
    cookies: true, // Mengizinkan Sentry mengakses cookies untuk session tracking
    databaseQueryData: true, // Mengizinkan Sentry mengakses data query database (jika ada)
    userInfo: true, // Mengizinkan Sentry mengakses informasi user (jika ada)
    urlQueryParams: true, // Mengizinkan Sentry mengakses parameter query URL
    frameContextLines: 5, // Jumlah baris kode sebelum dan sesudah frame error yang ditampilkan di dashboard Sentry
    stackFrameVariables: true, // Mengizinkan Sentry mengakses variabel lokal di setiap frame stack trace
  },
  
   ignoreErrors: [
    'Network Error',
    'Failed to fetch',
    'NetworkError when attempting to fetch resource.',
  ],

  integrations: [
    // Melacak performa rendering & navigasi browser
    Sentry.browserTracingIntegration(),
    // Merekam sesi user (Session Replay)
    Sentry.replayIntegration({
      maskAllText: true,     // Menutupi teks sensitif (privasi user)
      blockAllMedia: true,    // Menutupi media/gambar
    }),
  ],

  // Sampling rate untuk tracing performa (1.0 = 100% request dipantau)
  tracesSampleRate: 1.0,

  // Session Replay sampling
  replaysSessionSampleRate: 0.1, // Rekam 10% sesi normal
  replaysOnErrorSampleRate: 1.0,  // Rekam 100% sesi yang mengalami error/crash

  // Menentukan environment
  environment: import.meta.env.MODE || "production",
});



ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    {/* Error Boundary untuk mencegah layar putih total saat komponen crash */}
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div style={{ padding: "20px", textAlign: "center" }}>
          <h2>Terjadi kesalahan pada tampilan.</h2>
          <p style={{ color: "red" }}>{error.message}</p>
          <button onClick={() => resetError()}>Coba Lagi</button>
        </div>
      )}
    >
      <QueryClientProvider client={queryClient}>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3500,
            style: {
              background: '#0f172a',
              color: '#fff',
              borderRadius: '12px',
            },
            success: {
              style: {
                background: '#065f46',
              },
            },
            error: {
              style: {
                background: '#991b1b',
              },
            },
          }}
        />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
